module.exports = __webpack_public_path__ + "static/media/242 Park - Exterior Draft 3.2289229e.jpg";